import React, { Component, useState } from 'react'
import { useHistory } from 'react-router-dom'

import '../styles/participant.css'

import * as Inputs from './Inputs'

const RegistrationExtrasContainer = (props) => {
  const { me } = props
  const profile = props.me.profile || {}

  const history = useHistory()
  const [profileState, setProfile] = useState({
    username: props.me.username,
    gender: profile.gender || '',
    dob: profile.dob || '',
    ethnicity: profile.ethnicity || '',
    races: profile.races || [],
    cause_of_liver_disease: profile.cause_of_liver_disease || [],
    height: profile.height || '',
    weight: profile.weight || '',
    unit: profile.unit || 'imperial',
    age: profile.age || '',
  })

  const setAgeValue = (e) => {
    console.log(e)
    let now = new Date()
    let dob = +now.getFullYear() - e + '-07-01' //TODO - default date is per Andres' requirement but should be rethought
    setProfile({ ...profileState, dob: dob, age: e })
  }
  const onSubmit = () => {
    props
      .onSave(profileState)
      .then(() => {
        history.push('/welcome/2')
      })
      .catch((err) => {
        alert(err.toString())
      })
  }

  const filled = true

  return (
    <div>
      <div className="row">
        <div className="col-md-6 offset-md-3 p-4 shadow-lg rounded baseline-evaluation">
          <h2>Step 1/2: Complete your Profile</h2>
          <p>
            Welcome to EL-FIT! To get started, complete your profile by filling in the information
            below. Your information will be stored securely over the course of the study and will
            help us provide you with targeted exercise guidance and feedback. You can edit your
            profile at any time.
          </p>

          <div className="p-2">
            <h4>EL-FIT Nickname</h4>
            <Inputs.Text
              value={profileState.username}
              style={{ width: 200 }}
              onChange={(value) => setProfile({ ...profileState, username: value })}
            />
            <div className="text-sm hint" style={{ marginTop: 10, maxWidth: 400 }}>
              Other EL-FIT participants will see your nickname instead of your real name in the
              leaderboards.
            </div>
          </div>

          <div className="p-2">
            <h4>Gender</h4>
            <Inputs.Radio
              id="gender"
              value={profileState.gender}
              options={[
                ['Female', 'female'],
                ['Male', 'male'],
              ]}
              onChange={(value) => setProfile({ ...profileState, gender: value })}
            />
          </div>

          <div className="p-2">
            <h4>Age</h4>
            <p>Enter your current age in years</p>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Inputs.Numeric
                style={{ width: 60, marginLeft: 10 }}
                className="form-control"
                onChange={(value) => setAgeValue(value)}
                value={profileState.age}
                min={18}
                max={100}
              />
            </div>
          </div>

          <div className="p-2">
            <h4>Unit</h4>
            {console.log(profileState)}
            <Inputs.Radio
              id="unit"
              value={profileState.unit}
              options={[
                ['Metric', 'metric'],
                ['Imperial', 'imperial'],
              ]}
              onChange={(value) => setProfile({ ...profileState, unit: value })}
            />
          </div>

          <div className="p-2">
            <h4>Height</h4>
            <Inputs.Height
              value={profileState.height}
              style={{ width: 100 }}
              onChange={(value) => setProfile({ ...profileState, height: value })}
              min={0}
              max={300}
              unit={profileState.unit}
            />
          </div>

          <div className="p-2">
            <h4>Weight</h4>
            <Inputs.Weight
              value={profileState.weight}
              style={{ width: 100 }}
              onChange={(value) => setProfile({ ...profileState, weight: value })}
              min={0}
              max={1000}
              showHint={false}
              unit={profileState.unit}
            />
          </div>

          <div className="p-2">
            <h4>Self-identified Ethnicity</h4>
            <Inputs.Radio
              id="ethnicity"
              value={profileState.ethnicity}
              options={[
                ['Not Hispanic or Latino', 'not-latino'],
                ['Hispanic or Latino', 'latino'],
              ]}
              onChange={(value) => setProfile({ ...profileState, ethnicity: value })}
            />
          </div>

          <div className="p-2">
            <h4>Self-identified Race</h4>
            <Inputs.SelectMultiple
              value={profileState.races}
              options={[
                ['White', 'white'],
                ['Black', 'black'],
                ['Asian', 'asian'],
                ['Other', 'other'],
                ['Indian / Alaskan', 'indian'],
                ['Hawaiian / Pacific Is.', 'hawaiian'],
              ]}
              onChange={(value) => setProfile({ ...profileState, races: value })}
            />
          </div>

          <div className="p-2">
            <h4>Cause of Liver Disease</h4>
            <Inputs.SelectMultiple
              value={profileState.cause_of_liver_disease}
              options={[
                ['Viral Hepatitis', 'viral hepatitis'],
                ['Alcohol Use', 'alcohol'],
                ['NASH', 'nash'],
                ['Autoimmune', 'autoimmune'],
                ['Cholestatic', 'cholestatic'],
                ['Metabolic', 'metabolic'],
                ['Other', 'other'],
                ['Cryptogenic', 'cryptogenic'],
              ]}
              onChange={(value) => setProfile({ ...profileState, cause_of_liver_disease: value })}
            />
          </div>

          <button
            style={{ marginTop: 30, marginBottom: 30 }}
            disabled={!filled}
            className="btn btn-primary btn-block"
            onClick={() => onSubmit()}
          >
            Save Profile
          </button>
        </div>
      </div>
    </div>
  )
}

export default RegistrationExtrasContainer
